/* eslint-disable react/jsx-no-literals */
import React from 'react';
import styled from 'styled-components';

const GanttProgressHeader: React.FC = () => {
  return (
    <ProgressHeaderContainer>
      <HeaderLabel>Progress</HeaderLabel>
    </ProgressHeaderContainer>
  );
};

const ProgressHeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HeaderLabel = styled.div`
  font-size: 12px;
  font-weight: 900;
  color: ${({ theme }) => theme.palette.brand.primary};
  text-align: center;
`;

export { GanttProgressHeader };
